import React, { useId } from 'react';

import { getLocation } from '$utilities/location';
import IconSearch from '$partials/icons/icon-search';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 *
 * @type {import('$types/components/partials/articles.d.ts').ArticleNavBar}
 */
const ArticleNavBar = (props) => {
    const location = getLocation();
    const formId = useId();

    return (
        <div className='-mx-layout-outer md:mx-0 theme-light'>
            <nav className='flex flex-wrap-reverse md:flex-nowrap justify-between bg-main-background md:bg-[transparent] px-layout-outer pt-16 md:pt-0 md:px-0'>
                {/* Pages */}
                {props.pages?.length> 0 && (
                    <div className='flex gap-x-6'>
                        {props.pages.map((page) => {
                            const isActive = page.url === location.pathname;
                            return (
                                <a
                                    className={`block type-style-eyebrow px-16 py-13 rounded hover:bg-tab-background-hover ${isActive ? 'bg-tab-background-selected' : 'bg' }`}
                                    href={page.url}
                                    key={page.url}>
                                    {page.title}
                                </a>
                            );
                        })}
                    </div>
                )}
                {/* Search */}
                <div className='w-full md:max-w-[270px] pb-16 md:pb-0'>
                    <form
                        className='w-full flex relative'
                        role='search'>
                        <div
                            aria-hidden={true}
                            className='absolute top-12 left-12 pointer-events-none'>
                            <IconSearch/>
                        </div>
                        <label
                            className='sr-only'
                            htmlFor={formId}>
                            {'Search term'}
                        </label>
                        <input
                            className='w-full py-10 pr-12 pl-35 text-[16px] md:text-[12px] type-style-eyebrow h-[44px] bg-input-background md:bg-main-background rounded'
                            defaultValue={props.searchTerm || ''}
                            id={formId}
                            name='searchTerm'
                            placeholder='Search'
                            type='text' />
                    </form>
                </div>
            </nav>
        </div>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default ArticleNavBar;
